import { useEffect, useRef } from 'react';
import { FormInputField, FormInputFieldProps } from '@mews/framework';
import { PasswordField, PasswordFieldProps } from '@mews-commander/form';

export const AutofocusedInputField = (props: FormInputFieldProps) => {
    const inputRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        inputRef.current?.focus();
    }, []);

    return <FormInputField {...props} forwardedRef={inputRef} />;
};

export const AutofocusedPasswordField = (props: PasswordFieldProps) => {
    const inputRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        inputRef.current?.focus();
    }, []);

    return <PasswordField {...props} forwardedRef={inputRef} />;
};
